import { createContext, useContext } from 'react';
export const ErrorContext = /*#__PURE__*/ createContext();
export const ErrorDispatchContext = /*#__PURE__*/ createContext();
export const useErrorContext = ()=>useContext(ErrorContext);
export const useErrorDispatch = ()=>useContext(ErrorDispatchContext);
